import i18n from './i18n';
const { states } = i18n;
const statesUf = states.map((state) => ({
    label: state.value,
    value: state.value,
}));
const statesFullName = states.map((state) => ({
    label: state.label,
    value: state.label,
}));
const statesFormatted = {
    stateUf: statesUf,
    stateFullName: statesFullName,
};
export const getStatesByCountry = (typeFormat) => {
    if (typeFormat) {
        return statesFormatted[typeFormat];
    }
    return states;
};
